// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__iA8fd","right":"styles_right__1aJxC"};